<template>
	<div class="psi">
		<!-- 诊所描述Card -->
		<div class="inCard">
			
		</div>
		
		<div class="shop-header">
			<!-- <span>诊所管理</span> -->
			处方发药
		</div>
		

		
	</div>
</template>

<script>
	// selfs / sons
	import psiTabs from '../../external/comment/shopPlanheader.vue'
	
	export default {
		components: {
			psiTabs
		},
		data() {
			return {

			}
		},

		methods: {



		},

		//生命周期
		created() {
			
		},

	}
</script>

<style lang="less" scoped>
.psi{
	height: 100%;
	width: 100%;

}
</style>